import { mapPromosDetails } from './mapPromosDetails';
import { mapPromosPreview } from './mapPromosPreview';
import { IPromoDesktopSchema } from '../../repositories/newbuilding-promos/entities/promo/PromoDesktopSchema';
import { ISearchPromosV2ResponseSchema } from '../../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { IPromoDetailsById } from '../../types/promos/promoDetails';
import { IPromoItemById } from '../../types/promos/promos';

export const mapSearchPromos = (promosResponse: ISearchPromosV2ResponseSchema) => {
  const promos = promosResponse.promoSearchResult.promos;

  const previewById: IPromoItemById = {};
  const detailsById: IPromoDetailsById = {};

  const allIds = promos.map((promo: IPromoDesktopSchema) => {
    previewById[promo.uniquePromoId] = mapPromosPreview(promo);
    detailsById[promo.uniquePromoId] = mapPromosDetails(promo);

    return promo.uniquePromoId;
  });

  return {
    allIds,
    previewById,
    detailsById,
  };
};
